import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconComponent } from '../icon/icon.component';
import { NgClass, NgStyle, NgIf } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'sc-radio-button',
  styleUrls: ['./radio-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-radio-button
      #radioButton
      [value]="value"
      [checked]="selected"
      [ngClass]="{
        'radio-button-container-selected': selected
      }"
      [ngStyle]="{
        width: widthInPx ? widthInPx + 'px' : null
      }"
      [class]="getClassList()"
      (click)="spaceOrEnterVsButtonClicked.emit(false)"
      (keydown.enter)="spaceOrEnterVsButtonClicked.emit(true)"
      (keydown.space)="spaceOrEnterVsButtonClicked.emit(true)"
    >
      <span class="label">
        {{ label }}
      </span>

      <sc-icon
        class="right-icon"
        [ngClass]="{ 'clickable-icon': clickableIcon, 'has-value': value }"
        [name]="rightIcon"
        *ngIf="rightIcon"
        (click)="onRightIconClick(); tooltip.toggle()"
        [matTooltip]="toolTipText"
        matTooltipPosition="above"
        data-html="true"
        #tooltip="matTooltip"
      ></sc-icon>
      <ng-content select="[additionalAction]"></ng-content>
    </mat-radio-button>
  `,
  imports: [
    MatRadioModule,
    NgClass,
    NgStyle,
    NgIf,
    IconComponent,
    MatTooltipModule,
  ],
})
export class RadioButtonComponent {
  @Input() selected: boolean;
  @Input() widthInPx: string | number;
  @Input() label: string;
  @Input() value: any;
  @Input() clickableIcon = false;
  @Input() rightIcon: IconName;
  @Input() toolTipText: string;
  @Input() customClassList: string[] = [];

  @Output() rightIconClick = new EventEmitter<string>();
  @Output() spaceOrEnterVsButtonClicked = new EventEmitter<boolean>(); //only on space or enter (-> true) and click (-> false): not keyboard arrows

  onRightIconClick() {
    if (this.clickableIcon) {
      this.rightIconClick.emit(this.value);
    }
  }

  getClassList() {
    this.customClassList?.push('radio-button-container');
    return this.customClassList?.join(' ');
  }
}
